module.exports = __webpack_public_path__ + "img/big_1_2.d367ad1c.png";